import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Box, Icon, Tooltip } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import "./index.css";
import { object } from "yup/lib/locale";
import { mobileCheck } from "../common";

const useStyles = makeStyles((theme) => ({
  button: {
    "&:hover": {
      "box-shadow": "0 0 6px silver",
    },
  },
  dark: {
    color: "#333",
    borderColor: "#333",
  },
  light: {
    color: "#fff",
    borderColor: "#fff",
  },
}));

const useStylesBootstrap = makeStyles((theme) => ({
  arrow: {
    color: theme.palette.common.black,
  },
  tooltip: {
    backgroundColor: theme.palette.common.black,
  },
}));

function BootstrapTooltip(props) {
  const classes = useStylesBootstrap();

  return <Tooltip arrow classes={classes} {...props} />;
}

const defaultProps = {
  // m: 1,
  border: 1,
  style: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "48px",
    height: "48px",
    cursor: "pointer",
  },
};

const Menu = (props) => {
  const classes = useStyles();
  const { id } = useParams();
  const [menu, setMenu] = useState(null);
  const [horizontal, setHorizontal] = useState(false);

  useEffect(() => {
    if (!menu) {
      document.body.style.overflow = "hidden";
      window.parent.postMessage(
        { type: "menu", key: "getData", value: "" },
        "*"
      );
      window.addEventListener("message", (event) => {
        let data = event.data;
        if (data.type != "menu") return;
        //console.log(data);
        if (data.key == "setData") {
          const isMobile = mobileCheck();
          let menuTemplate = data.value.menuTemplates.find(
            (x) => (x.device == 1 && isMobile) || (x.device == 2 && !isMobile)
          );
          //console.log(menuTemplate);
          setMenu(data.value);
          if (menuTemplate) {
            let horizontal = menuTemplate.position.includes("center");
            setHorizontal(horizontal);
          }
        }
      });

      if (id) {
        fetch(`https://localhost:44341/api/public/menu/${id}`)
          .then((response) => {
            return response.json();
          })
          .then((json) => {
            setMenu(json);
          });
      }
    }
  }, [menu]);

  const handleClick = (item) => {
    window.parent.postMessage({ type: "menu", key: "click", value: item }, "*");
    return;

    if (item.action === 1) {
      window.open(item.actionValue);
    } else if (item.action === 1) {
      window.open(item.actionValue, "_blank");
    } else {
      eval(item.actionValue);
    }
  };

  return (
    <Box>
      {menu && !horizontal && (
        <Box
          display="flex"
          flexWrap="wrap"
          justifyContent={horizontal ? "space-evenly" : "center"}
          alignItems="center"
          marginTop={horizontal ? "8px" : "0"}
        >
          {menu.menuButtons.map((item, index) => (
            <BootstrapTooltip key={index} title={item.name}>
              <Box
                key={index}
                borderColor={menu.color}
                borderRadius={menu.borderRadius}
                bgcolor={menu.color}
                className={`${classes.button} ${classes.light}`}
                marginTop={horizontal ? "0" : "8px"}
                {...defaultProps}
                onClick={() => {
                  handleClick(item);
                }}
              >
                <Icon className={`${classes.light}`}>{item.icon}</Icon>
              </Box>
            </BootstrapTooltip>
          ))}
        </Box>
      )}
      {menu && horizontal && (
        <Box
          display="flex"
          justifyContent="space-evenly"
          height="60px"
          bgcolor={menu.color}
        >
          {menu.menuButtons.map((item, index) => (
            <Box
              key={index}
              display="flex"
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
              minWidth="32px"
              className={`${classes.light}`}
              onClick={() => {
                handleClick(item);
              }}
            >
              <Icon className={`${classes.light}`}>{item.icon}</Icon>
              <Box marginTop="6px" fontSize="12px">
                {item.name}
              </Box>
            </Box>
          ))}
        </Box>
      )}
    </Box>
  );
};

export default Menu;
